import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import * as SkeletonUtils from "three/examples/jsm/utils/SkeletonUtils";
import modelToMesh from "./modelToMesh";
import subtractMeshes from "./subtractMeshes";
import intersectMeshes from "./intersectMeshes";

const addPseudoFacing = async (
    sizeXbig,
    sizeZbig,
    sizeXsmall,
    sizeZsmall,
    height
) => {
    const bigMesh = new THREE.Mesh(
        new THREE.BoxGeometry(sizeXbig, height, sizeZbig),
        new THREE.MeshStandardMaterial()
    );

    const smallMesh = new THREE.Mesh(
        new THREE.BoxGeometry(sizeXsmall, height, sizeZsmall),
        new THREE.MeshStandardMaterial({ color: 0xff0000 })
    );
    smallMesh.position.copy(bigMesh.position);

    bigMesh.updateMatrix();
    smallMesh.updateMatrix();

    const subtractedMesh = await subtractMeshes(bigMesh, smallMesh);

    return subtractedMesh;
};

const addFacingTopStripe = async (_model, _mainElement3d, _mainElement) => {
    const napusk = 0;

    const facingGroup = new THREE.Group();

    const plitka = await modelToMesh(_model);
    const plitkaBbox = getPosInfo(plitka);

    const mainElement3dBbox = getPosInfo(_mainElement3d);

    const sizeXbig = mainElement3dBbox.xSize + napusk * 2;
    const sizeZbig = mainElement3dBbox.zSize + napusk * 2;

    const sizeXsmall =
        sizeXbig - (_mainElement.thickness / 100) * 2 - napusk * 4;
    const sizeZsmall =
        sizeZbig - (_mainElement.thickness / 100) * 2 - napusk * 4;

    const pseudoFacing = await addPseudoFacing(
        sizeXbig,
        sizeZbig,
        sizeXsmall,
        sizeZsmall,
        plitkaBbox.ySize
    );

    const countInX = Math.ceil(sizeXbig / plitkaBbox.xSize);
    const countInZ = Math.ceil(sizeZbig / plitkaBbox.zSize);

    let intersectedPlitka;

    plitka.position.set(
        mainElement3dBbox.bbox.min.x + plitkaBbox.xSize / 2 - napusk,
        0,
        mainElement3dBbox.bbox.min.z + plitkaBbox.zSize / 2 - napusk
    );
    plitka.updateMatrix();
    intersectedPlitka = await intersectMeshes(pseudoFacing, plitka);
    facingGroup.add(intersectedPlitka);

    for (let index = 2; index <= countInX; index++) {
        const newPlitka = SkeletonUtils.clone(plitka);
        newPlitka.position.x += (index - 1) * plitkaBbox.xSize;
        newPlitka.updateMatrix();
        intersectedPlitka = await intersectMeshes(pseudoFacing, newPlitka);
        facingGroup.add(intersectedPlitka);
    }

    for (let indexZ = 2; indexZ <= countInZ; indexZ++) {
        const newPlitkaZ = SkeletonUtils.clone(plitka);
        newPlitkaZ.position.z += (indexZ - 1) * plitkaBbox.zSize;
        newPlitkaZ.updateMatrix();
        intersectedPlitka = await intersectMeshes(pseudoFacing, newPlitkaZ);
        facingGroup.add(intersectedPlitka);

        for (let indexX = 2; indexX <= countInX; indexX++) {
            const newPlitka = SkeletonUtils.clone(newPlitkaZ);
            newPlitka.position.x += (indexX - 1) * plitkaBbox.xSize;
            newPlitka.updateMatrix();
            intersectedPlitka = await intersectMeshes(pseudoFacing, newPlitka);
            facingGroup.add(intersectedPlitka);
        }
    }

    facingGroup.position.copy(_mainElement3d.position);
    facingGroup.updateMatrix();
    return facingGroup;
};
export default addFacingTopStripe;
